import { render, staticRenderFns } from "./MerchantAppsPreOrder.vue?vue&type=template&id=c62ff818&scoped=true"
import script from "./MerchantAppsPreOrder.vue?vue&type=script&lang=js"
export * from "./MerchantAppsPreOrder.vue?vue&type=script&lang=js"
import style0 from "./MerchantAppsPreOrder.vue?vue&type=style&index=0&id=c62ff818&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62ff818",
  null
  
)

export default component.exports